import React, { useState, useEffect } from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  MenuItem,
  FormControl,
  InputLabel,
  Select,
  OutlinedInput,
  Checkbox,
  ListItemText
} from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import { saveProduct, updateProduct, fetchProducts, deleteProduct } from '../service/productService';
import { getCurrencies, getSubcategories } from '../service/commonService';
import { fetchBrand } from '../service/brandService';
import { fetchCoupon } from '../service/couponService';
import { fetchSuppliers } from '../service/supplierService';
import { fetchDiscount } from '../service/discountService';


export default function ProductManager() {
  const [products, setProducts] = useState([]);
  const [currencies, setCurrencies] = useState([]);
  const [subCategories, setSubCategories] = useState([]);
  const [brands, setBrands] = useState([]);
  const [tags, setTags] = useState([]);
  const [coupons, setCoupons] = useState([]);
  const [suppliers, setSuppliers] = useState([]);
  const [discounts, setDiscounts] = useState([]);
    

  const [open, setOpen] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState(null);

  // Fetch data
  useEffect(() => {
    loadData();
  }, []);

  const loadData = async () => {
    const prodRes = await fetchProducts(); //axiosInstance.get("/api/products");
    setProducts(prodRes.data);

    const currencyRes = await getCurrencies(); //axiosInstance.get("/api/currencies");
    setCurrencies(currencyRes.data.content);

    const subCatRes = await getSubcategories();
    setSubCategories(subCatRes.data);

    const brandRes = await fetchBrand(); //axiosInstance.get("/api/brands");
    setBrands(brandRes);
      
     const couponRes = await fetchCoupon();
      setCoupons(couponRes);
      
     const supplierRes = await fetchSuppliers();
     setSuppliers(supplierRes.data);
      
     const discountRes = await fetchDiscount();
     setDiscounts(discountRes);

    //const tagRes = await axiosInstance.get("/api/tags");
    //setTags(tagRes.data);
  };
  
  
  
  

  const handleOpen = (product = null) => {
    setSelectedProduct(product || {
      productName: "",
      description: "",
      basePrice: "",
      maxPrice: "",
    //  salesPrice: "",
      currencyId: "",
      supplierId: "",
      sku: "",
      subCategoryId: "",
      brandId: "",
     // tagIds: [],
      isActive: true,
      sharedDiscount: null,
      couponDiscount: null,
    });
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    setSelectedProduct(null);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setSelectedProduct((prev) => ({ ...prev, [name]: value }));
  };
    
 
    
   const handleProductChange = (e) => {
    const { name, value } = e.target;

    if (name === "couponId") {
      setSelectedProduct((prev) => ({
        ...prev,
        couponDiscount: {
          ...prev.couponDiscount,
          [name]: value
        }
      }));
    } else if (name === "discountId") {
      setSelectedProduct((prev) => ({
        ...prev,
        sharedDiscount: {
          ...prev.sharedDiscount,
          [name]: value
        }
      }));
    } else {
      setSelectedProduct((prev) => ({ ...prev, [name]: value }));
    }
  };

  const handleSave = async () => {
    if (selectedProduct.productId) {
      await updateProduct(selectedProduct.productId, selectedProduct); //axiosInstance.put(`/api/products/${selectedProduct.productId}`, selectedProduct);
    } else {
      await saveProduct(selectedProduct); //axiosInstance.post("/api/products", selectedProduct);
    }
    loadData();
    handleClose();
  };

  const handleDelete = async (id) => {
      if (window.confirm("Are you sure you want to delete this?")) {
    await deleteProduct(id); // axiosInstance.delete(`/api/products/${id}`);
    loadData();
      }
  };

  const columns = [
    { field: "productName", headerName: "Product Name", flex: 1 },
    { field: "basePrice", headerName: "Base Price", flex: 1 },
    { field: "maxPrice", headerName: "Max Price", flex: 1 },
    { field: "sku", headerName: "SKU", flex: 1 },
    { field: "isActive", headerName: "Active", flex: 1, renderCell: (params) => (params.value ? "Yes" : "No") },
    {
      field: "actions",
      headerName: "Actions",
      flex: 1,
      renderCell: (params) => (
        <>
          <Button size="small" onClick={() => handleOpen(params.row)}>Edit</Button>
          <Button size="small" onClick={() => handleDelete(params.row.productId)}>Delete</Button>
          <Button size="small" onClick={() => alert(JSON.stringify(params.row, null, 2))}>View</Button>
        </>
      ),
    },
  ];

  return (
    <div style={{ height: 600, width: "100%" }}>
      <Button variant="contained" color="primary" onClick={() => handleOpen()}>
        Add Product
      </Button>
      <DataGrid
        rows={products}
        columns={columns}
        getRowId={(row) => row.productId}
        pageSize={10}
        rowsPerPageOptions={[10, 20, 50]}
        filterModel={{
          items: [
            { columnField: "productName", operatorValue: "contains", value: "" }
          ]
        }}
      />

      {/* Product Form Dialog */}
      <Dialog open={open} onClose={handleClose} fullWidth maxWidth="md">
        <DialogTitle>{selectedProduct?.productId ? "Edit Product" : "Add Product"}</DialogTitle>
        <DialogContent>
          <TextField
            fullWidth
            margin="dense"
            name="productName"
            label="Product Name"
            value={selectedProduct?.productName || ""}
            onChange={handleChange}
          />
          <TextField
            fullWidth
            margin="dense"
            name="description"
            label="Description"
            value={selectedProduct?.description || ""}
            onChange={handleChange}
          />
            <FormControl fullWidth  margin="dense">
            <InputLabel id="supplierId-label">Supplier</InputLabel>
            <Select
              labelId="supplierId-label"
              id="supplierId"
              name="supplierId"
              value={selectedProduct?.supplierId || ""}
              onChange={handleChange}
              label="Supplier">
              <MenuItem value="">
                <em>Select Supplier</em>
              </MenuItem>
              {suppliers.map((c) => (
                  <MenuItem key={c.supplierId} value={c.supplierId}>
                    {c.supplierName}
                  </MenuItem>
                ))}
            </Select>
          </FormControl>

            <TextField
            margin="dense"
            name="imageUrl"
            value={selectedProduct?.imageUrl || ""}
            onChange={handleChange}
            label="Image URL"
            fullWidth
          />
                  <TextField
            name="basePrice"
            margin="dense"
            type="number"
            value={selectedProduct?.basePrice || ""}
            onChange={handleChange}
            label="Base Price"
            fullWidth
          />

            <FormControl fullWidth  margin="dense">
            <InputLabel id="discount-label">Discount</InputLabel>
            <Select
              labelId="discount-label"
              id="discountId"
              name="discountId"
              value={selectedProduct?.sharedDiscount?.discountId || ""}
              onChange={handleProductChange}
              label="Discount">
              <MenuItem value="">
                <em>Select Discount</em>
              </MenuItem>
              {discounts.map((c) => (
                <MenuItem key={c.discountId} value={c.discountId}>
                  {c.percentage} - {c.amount}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
      
          <FormControl fullWidth margin="dense">
            <InputLabel id="coupon-label">Coupon</InputLabel>
            <Select
              labelId="coupon-label"
              id="couponId"
              name="couponId"
              value={selectedProduct?.couponDiscount?.couponId || ""}
              onChange={handleProductChange}
              label="Coupon">
              <MenuItem value="">
                <em>Select Coupon</em>
              </MenuItem>
              {coupons &&
                coupons.map((c) => (
                  <MenuItem key={c.couponId} value={c.couponId}>
                    {c.code} - {c.discountType} - {c.discountValue}
                  </MenuItem>
                ))}
            </Select>
          </FormControl>
       
          <TextField
            name="maxPrice"
            type="number"
            margin="dense"
            value={selectedProduct?.maxPrice}
            onChange={handleChange}
            label="Max Price"
            fullWidth
          />

          <TextField
            name="maxOrderQuantityPerUser"
            type="number"
            margin="dense"
            value={selectedProduct?.maxOrderQuantityPerUser}
            onChange={handleChange}
            label="Max Order Per User"
            fullWidth
          />
         {/* 
          <TextField
            name="salesPrice"
            type="number"
            margin="dense"
            value={selectedProduct?.salesPrice}
            onChange={handleChange}
            label="Sales Price"
            fullWidth
          />
              */}
          <TextField
            name="availableCountry"
            value={selectedProduct?.availableCountry}
            onChange={handleChange}
            label="Country"
            fullWidth
            margin="dense"
          />
          <TextField
            name="availableState"
            margin="dense"
            value={selectedProduct?.availableState}
            onChange={handleChange}
            label="State"
            fullWidth
          />
          <TextField
            name="availableCity"
            margin="dense"
            value={selectedProduct?.availableCity}
            onChange={handleChange}
            label="City"
            fullWidth
          />
          <TextField name="sku" value={selectedProduct?.sku} onChange={handleChange} 
           margin="dense"
           label="SKU" fullWidth />
               
        
          <FormControl fullWidth margin="dense">
            <InputLabel>Currency</InputLabel>
            <Select name="currencyId" value={selectedProduct?.currencyId || ""} onChange={handleChange}>
              {currencies && currencies.map(c => <MenuItem key={c.currencyId} value={c.currencyId}>{c.code}</MenuItem>)}
            </Select>
          </FormControl>
          <FormControl fullWidth margin="dense">
            <InputLabel>Sub Category</InputLabel>
            <Select name="subCategoryId" value={selectedProduct?.subCategoryId || ""} onChange={handleChange}>
              {subCategories && subCategories.map(sc => <MenuItem key={sc.subCategoryId} value={sc.subCategoryId}>{sc.name}</MenuItem>)}
            </Select>
          </FormControl>
          <FormControl fullWidth margin="dense">
            <InputLabel>Brand</InputLabel>
            <Select name="brandId" value={selectedProduct?.brandId || ""} onChange={handleChange}>
              {brands && brands.map(b => <MenuItem key={b.brandId} value={b.brandId}>{b.name}</MenuItem>)}
            </Select>
          </FormControl>
         {/*  <FormControl fullWidth margin="dense">
            <InputLabel>Tags</InputLabel>
            <Select
              multiple
              name="tagIds"
              value={selectedProduct?.tagIds || []}
              onChange={handleChange}
              input={<OutlinedInput label="Tags" />}
              renderValue={(selected) =>
                tags.filter(tag => selected.includes(tag.tagId)).map(t => t.name).join(", ")
              }
            >
              {tags && tags.map(tag => (
                <MenuItem key={tag.tagId} value={tag.tagId}>
                  <Checkbox checked={selectedProduct?.tagIds?.includes(tag.tagId)} />
                  <ListItemText primary={tag.name} />
                </MenuItem>
              ))}
            </Select>
          </FormControl>
*/}
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Cancel</Button>
          <Button variant="contained" color="primary" onClick={handleSave}>Save</Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
